import { Code } from 'lucide-react'
import SocialMediaEmbed from '../SocialMedia/SocialMediaEmbed.js'
import i18next from 'i18next'
import { NodeViewProps } from '@tiptap/react'

export default (props: NodeViewProps) => {
  const { src, width = '100%', height = '400', title } = props?.node?.attrs ?? {}

  return (
    <SocialMediaEmbed
      props={props}
      Icon={Code}
      text={i18next.t('embedIframe') || 'Embed an Iframe (Flourish, Datawrapper, etc.)'}
    >
      <div className="iframe-wrapper w-full">
        <iframe
          src={src ?? ''}
          width={width}
          height={height}
          title={title ?? 'Embedded content'}
          allowFullScreen
          loading="lazy"
          sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-presentation"
          referrerPolicy="no-referrer-when-downgrade"
          style={{
            border: 'none',
            width: '100%',
            minHeight: '300px',
          }}
        />
      </div>
    </SocialMediaEmbed>
  )
}
